const usersEvents = {
  select: 'app/modules/users/select',
  load: {
    start: 'app/modules/users/load/start',
    success: 'app/modules/users/load/success',
    error: 'app/modules/users/load/error',
    finish: 'app/modules/users/load/finish',
  },
  modal: {
    open: 'app/modules/users/modal/open',
    close: 'app/modules/users/modal/close',
    save: 'app/modules/users/modal/save',
  },
  edit: {
    open: 'app/modules/users/edit/open',
    close: 'app/modules/users/edit/close',
    save: 'app/modules/users/edit/save',
  },
  revoke: {
    open: 'app/modules/users/revoke/open',
    close: 'app/modules/users/revoke/close',
    save: 'app/modules/users/revoke/save',
  },
  brandAdmin: {
    open: 'app/modules/users/brandAdmin/open',
    close: 'app/modules/users/brandAdmin/close',
    save: 'app/modules/users/brandAdmin/save',
  },
};

export default usersEvents;
